import wrappedAxios from "../axiosWrapper";
import {
  DataSourceModel,
  DataSources,
  DataSourceState,
  HegClassesFolders,
  MappedDataSources,
} from "./types";
import * as urlParsers from "./urlParsers";
import { AdministrationTableRow, Table } from "../table/types";
import { SOR, StringIndexedDictionary } from "../../globalTypes";

export const fetchDataSources = () =>
  wrappedAxios<DataSources>({
    url: urlParsers.getDataSources(),
    method: "GET",
  });

export const fetchDataSourceById = (dataSourceId: number) =>
  wrappedAxios<DataSourceModel>({
    url: urlParsers.getDataSourceById(dataSourceId),
    method: "GET",
  });

export const deleteDataSource = (rowKey: number) =>
  wrappedAxios<string>({
    url: urlParsers.deleteDataSource(rowKey),
    method: "DELETE",
  });

export const fetchDataSourceTableRow = (rowKey: number) =>
  wrappedAxios<AdministrationTableRow>({
    url: urlParsers.getAdministrationDataSourceTableRow(rowKey),
    method: "GET",
  });

export const fetchAdministrationDataSourceTable = (
  pageNum: number,
  maxPageRowCount: number,
  searchOrder: SOR,
  hiddenColumns: string[],
  fulltextKeyword: string | undefined
) =>
  wrappedAxios<Table>({
    url: urlParsers.getAdministrationDataSourceTable(
      pageNum,
      maxPageRowCount,
      JSON.stringify(searchOrder),
      hiddenColumns,
      fulltextKeyword
    ),
    method: "GET",
  });

export const insertDataSourceTableRow = (templateData: DataSourceModel) =>
  wrappedAxios<string>({
    url: urlParsers.postDataSource(),
    method: "POST",
    data: {
      ...templateData,
    },
  });

export const updateDataSourceTableRow = (
  templateData: DataSourceModel,
  rowId: string | number
) =>
  wrappedAxios<string>({
    url: urlParsers.updateDataSource(rowId),
    method: "PATCH",
    data: {
      ...templateData,
    },
  });

export const fetchDataSourceStateById = (dataSourceId: number) =>
  wrappedAxios<DataSourceState>({
    url: urlParsers.checkDataSourceState(dataSourceId),
    method: "GET",
  });

export const fetchDataSourcesStates = (idsOfDataSources: number[]) =>
  wrappedAxios<StringIndexedDictionary<DataSourceState>>({
    url: urlParsers.checkDataSourcesStates(),
    method: "POST",
    data: [...idsOfDataSources],
  });

export const fetchMappedDataSources = (idsOfDataSourcesToCheck: number[]) =>
  wrappedAxios<MappedDataSources>({
    url: urlParsers.getMappedDataSources(),
    method: "POST",
    data: [...idsOfDataSourcesToCheck],
  });

export const fetchMappedDataSourcesForUserId = (
  userId: number,
  idsOfDataSourcesToCheck: number[]
) =>
  wrappedAxios<MappedDataSources>({
    url: urlParsers.getMappedDataSourcesByUserId(userId),
    method: "POST",
    data: [...idsOfDataSourcesToCheck],
  });

export const postResetColumnSchema = (datasourceId: number) =>
  wrappedAxios<void>({
    url: urlParsers.postResetColumnSchema(),
    method: "POST",
    data: {
      datasourceId,
    },
  });

export const getTimeZoneOptions = () =>
  wrappedAxios<Record<string, string>>({
    url: urlParsers.getTimeZoneOptionsUrl(),
    method: "GET",
  });

export const getHegFoldersAndClassesByDatasourceId = (datasourceId: number) =>
  wrappedAxios<HegClassesFolders>({
    url: urlParsers.getHegClassesFolders(datasourceId),
    method: "POST",
  });
